/**
 * Nano Stores state management for Clerk authentication
 * Provides global state atoms for Clerk instance and user data
 */

import { atom, computed } from 'nanostores';

/**
 * Core state atoms
 */

// Clerk instance - stores the loaded Clerk object
export const clerkInstance = atom(null);

// Current Clerk user object
export const clerkUser = atom(null);

// Loading state - tracks if Clerk has finished loading
export const isClerkLoaded = atom(false);

// Error state - stores any Clerk loading errors
export const clerkError = atom(null);

/**
 * Computed values - derived from core atoms
 */

// Check if user is authenticated
export const isAuthenticated = computed(
  [clerkUser],
  (user) => user !== null
);

// Check if user is admin (based on publicMetadata)
export const isAdmin = computed(
  [clerkUser],
  (user) => user?.publicMetadata?.is_admin === true || false
);

/**
 * Helper function to get current Clerk instance
 * @returns {object|null} The Clerk instance or null if not loaded
 */
export function getClerk() {
  return clerkInstance.get();
}

/**
 * Helper function to get current user
 * @returns {object|null} The Clerk user or null if not authenticated
 */
export function getUser() {
  return clerkUser.get();
}

/**
 * Helper function to check if Clerk is loaded
 * @returns {boolean} True if Clerk is loaded
 */
export function isLoaded() {
  return isClerkLoaded.get();
}

/**
 * Helper function to get last error
 * @returns {Error|null} The last error or null
 */
export function getError() {
  return clerkError.get();
}
